import { useTranslation } from "react-i18next";
import LangIcon from "./LangIcon";
import { supportedLngs } from "./config";
import { useEffect, useRef, useState } from "react";

export default function LocaleSwitcher() {
  const { i18n } = useTranslation();
  const [isHidden, setIsHidden] = useState(false);
  const prevScrollPos = useRef(0);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      if (prevScrollPos.current > currentScrollPos) {
        setIsHidden(false);
      } else {
        setIsHidden(true);
      }
      prevScrollPos.current = currentScrollPos;
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleLanguageChange = (e) => {
    const newLang = e.target.value;
    i18n.changeLanguage(newLang);
    // Update SEO tags after i18next has loaded the new language
    i18n.on("languageChanged", (lng) => {
      if (window.setLanguage) window.setLanguage(lng);
    });
  };

  return (
    <div className={`locale-switcher_container ${isHidden ? "hidden" : ""}`}>
      <div className="locale-switcher">
        <LangIcon />
        <select value={i18n.resolvedLanguage} onChange={handleLanguageChange}>
          {Object.entries(supportedLngs).map(([code, name]) => (
            <option value={code} key={code}>
              {name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
